import { PropsWithChildren, FC, useState, useRef, useEffect } from 'react'
import { shipmentLines_shipment_shipmentLines_items_dfmFeedback as DfmFeedbackType } from '@Orders/OrderDetailsPage/Queries/__generated__/shipmentLines'

import Box from '~/core/Box'
import { DfmFeedbackSidebarType } from '~/apps/consumer/components/PartViewerModal/types'

import DfmFeedback from './DfmFragment'

export const DfmFeedbackSidebar: FC<
    PropsWithChildren<DfmFeedbackSidebarType>
> = props => {
    const [dfmCardObj, setDfmCardObj] = useState(props.cardObj)
    const [isSelected, setIsSelected] = useState(false)
    const clickRef = useRef<any>()

    useEffect(() => {
        const handleClickOutside = (event: Event) => {
            if (!clickRef?.current?.contains(event.target)) {
                const result: any = []

                for (const dfmId in dfmCardObj) {
                    if (dfmCardObj[dfmId]) {
                        result[dfmId] = false
                    }
                }

                setDfmCardObj(result)
                setIsSelected(false)
            }
        }

        window.addEventListener('click', handleClickOutside)
        return () => window.removeEventListener('click', handleClickOutside)
    }, [dfmCardObj])

    const onHoveredDfmFeedback = (id: string) => {
        const { onHoverDfmFeedback } = props

        onHoverDfmFeedback({
            dfmFeedbackId: id,
        })
    }

    const shouldExpandCard = (id: any) => {
        if (dfmCardObj[id]) {
            return false
        }

        const result: any = []

        for (const dfmId in dfmCardObj) {
            if (dfmCardObj[dfmId]) {
                result[dfmId] = false
            }
        }
        result[id] = true

        setDfmCardObj(result)
    }

    const onClickDfmFeedback = (feedback: DfmFeedbackType) => {
        const { onSelectDfmFeedback } = props

        if (!feedback) {
            return
        }

        setIsSelected(true)
        onSelectDfmFeedback({
            dfmFeedbackId: feedback.id,
            dfmSnapshot: feedback.modelViewerSnapshots[0]?.snapshot,
            focus: true,
        })
    }

    const renderDfmFeedback = (feedback: DfmFeedbackType) => {
        const { activeDfmFeedbackId, hoveredDfmFeedbackId } = props

        const active = activeDfmFeedbackId === feedback.id && isSelected
        const hovered = hoveredDfmFeedbackId === feedback.id
        const isCardActive = dfmCardObj[feedback.id] ? true : false

        return (
            <DfmFeedback
                id={feedback.id}
                key={feedback.id}
                active={active}
                hovered={hovered}
                feedback={feedback}
                onClickDfmFeedback={onClickDfmFeedback}
                onHoveredDfmFeedback={onHoveredDfmFeedback}
                shouldExpandCard={shouldExpandCard}
                shouldExpand={isCardActive}
            />
        )
    }

    const renderAllDfmFeedback = (dfmFeedbacks: DfmFeedbackType[]) =>
        dfmFeedbacks.map(dfm => renderDfmFeedback(dfm))

    return (
        <Box paddingBottom="64px" flex height="100%" direction="col">
            <Box
                direction="col"
                height="100%"
                style={{ overflowY: 'auto' }}
                ref={clickRef}
            >
                {renderAllDfmFeedback(props.dfmFeedbacks)}
            </Box>
        </Box>
    )
}

export default DfmFeedbackSidebar
